import React from "react";
import { absoluteUrl } from "../services/changelogApi";

// Screenshots from before the admin editor ship with the site bundle; anything
// uploaded through the editor is served by the backend.
const importAll = r => {
  const map = {};
  r.keys().forEach(key => {
    map[key.replace("./", "")] = r(key);
  });
  return map;
};

// require.context is webpack-only (it must stay a direct call so webpack can see it);
// under Jest it doesn't exist, so there are no bundled images.
let bundledImages = {};
try {
  bundledImages = importAll(require.context("../../../assets/changelog", false, /\.(png|jpe?g|svg|webp|gif)$/i));
} catch {
  bundledImages = {};
}

export function imageSrc(detail) {
  if (!detail?.image) return null;
  if (detail.imageUrl) return absoluteUrl(detail.imageUrl);
  if (bundledImages[detail.image]) return bundledImages[detail.image];
  return absoluteUrl(`/api/changelog/images/${encodeURIComponent(detail.image)}`);
}

export const TYPE_META = {
  feature: { label: "Features", className: "cl-tag--feature" },
  enhancement: { label: "Enhancement", className: "cl-tag--enhancement" },
  bugfix: { label: "Bug Fixes", className: "cl-tag--fix" },
};

export const tagFor = detail => {
  const meta = TYPE_META[detail.type] || TYPE_META.feature;
  return { text: detail.label || meta.label, className: meta.className };
};

/** Splits a trailing " — Beta" / " - Beta" / " (Beta)" off a title so it can show as a badge. */
export const splitBeta = title => {
  const match = String(title || "").match(/^(.*?)\s*(?:[—–-]\s*Beta|\(Beta\))\s*$/i);
  return match ? { text: match[1], beta: true } : { text: title, beta: false };
};

/** Plain text with **bold** segments. Never renders HTML. */
export function RichText({ text }) {
  const parts = String(text || "").split(/\*\*(.+?)\*\*/g);
  return parts.map((part, i) => (i % 2 === 1 ? <strong key={i}>{part}</strong> : <React.Fragment key={i}>{part}</React.Fragment>));
}

export const formatDate = iso => {
  if (!iso) return null;
  const d = new Date(`${iso}T00:00:00`);
  return Number.isNaN(d.getTime()) ? null : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};
